import React from 'react';
import * as Styled from '../Navigation.styled';
import { useRuntimeCommunity } from '../../../context';

export const DEFAULT_COMMUNITY_LOGO = '/r/templates/common/images/default-logo.png';

export const CommunityLogo = () => {
  const { logo, name } = useRuntimeCommunity();

  return logo ? (
    <Styled.AppLogo>
      <Styled.CommunityLogo aria-label={name} src={logo} data-testid="CommunityLogo" />
    </Styled.AppLogo>
  ) : (
    <span data-testid="EmptyCommunityLogo" />
  );
};
